import type React from "react";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import TrialGate from "@/components/TrialGate";
import {
	AdminPage,
	AuthPage,
	DocumentAnnotationView,
	KnowledgeGraphView,
	LandingPage,
	LogoutPage,
	NotebookLayout,
	ProcessingResultsPage,
	UploadPage,
	UserManagementPage,
	WaitingForApprovalPage,
} from "@/pages";

const AppRouter = (): React.JSX.Element => {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<LandingPage />} />
				<Route path="/landing" element={<Navigate to="/" replace />} />
				<Route
					path="/app"
					element={
						<TrialGate>
							<NotebookLayout />
						</TrialGate>
					}
				/>
				<Route
					path="/admin"
					element={
						<TrialGate>
							<AdminPage />
						</TrialGate>
					}
				/>
				<Route path="/auth" element={<AuthPage />} />
				<Route
					path="/user"
					element={
						<TrialGate>
							<UserManagementPage />
						</TrialGate>
					}
				/>
				<Route path="/logout" element={<LogoutPage />} />
				<Route
					path="/graph"
					element={
						<TrialGate>
							<KnowledgeGraphView />
						</TrialGate>
					}
				/>
				<Route path="/waiting" element={<WaitingForApprovalPage />} />
				<Route
					path="/upload"
					element={
						<TrialGate>
							<UploadPage
								onBack={() => window.history.back()}
								onViewAnnotation={() => {
									window.location.href = "/annotation";
								}}
								onViewAnnotationDirectly={() => {
									window.location.href = "/annotation";
								}}
							/>
						</TrialGate>
					}
				/>
				<Route
					path="/annotation"
					element={
						<TrialGate>
							<DocumentAnnotationView onBack={() => window.history.back()} />
						</TrialGate>
					}
				/>
				<Route
					path="/results/:jobId"
					element={
						<TrialGate>
							<ProcessingResultsPage />
						</TrialGate>
					}
				/>
			</Routes>
		</Router>
	);
};

export default AppRouter;
